import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateNavbarHeading } from '../../../constants/layout/store/filterSlice';
import { GetServiceCaller } from '../../../services/serviceCaller';
import { API_URL } from '../../../constants';
import Dynamic_PR_table from '../../../components/Dynamic_PR_table';
import moment from 'moment';

const SubscriptionSummary = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(updateNavbarHeading("Software Subscription Report"))
    }, [])
    const [searchTerm, setSearchTerm] = useState("");
    const [subscriptionSummaryListData, setSubscriptionSummaryListData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiStatus, SetApiStatus] = useState(undefined);

    const columns = {
        Brand: { text: "Make", align: "left", visible: true },
        PurchaseDate: { text: "Purchase Date", align: "center", visible: true },
        ExpiryDate: { text: "Expiry Date", align: "center", visible: true },
        VendorName: { text: "Vendor", align: "left", visible: true },
        AssetPrice: { text: "Price", align: "end", visible: true },
        Allocated: { text: "Status", align: "left", visible: true },
        AssetTypes: { text: "Assets", align: "left", visible: true },
        Description: { text: "Description", align: "left", visible: true },
        SubscriptionStartDate: { text: "Subscription Start Date", align: "Center", visible: false },
        SubscriptionEndDate: { text: "Subscription End Date", align: "Center", visible: false },
    };

    useEffect(() => {
        fetchGetSubscriptionSummaryReport();
    }, []);
    const fetchGetSubscriptionSummaryReport = async () => {
        try {
            const response = await GetServiceCaller(`${API_URL}support-desk-reports/4?P_FromDate=&P_ToDate=`);

            SetApiStatus(response?.status);
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setSubscriptionSummaryListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Subscription Summary Report. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Subscription Summary Report:", error);
        }
    };

    const [filterFormData, setFilterData] = useState([]);
    const formDatas = [

        {
            name: "From Date",
            type: "Date",
            // options: [...assetTypeOption]

        },
        {
            name: "To Date",
            type: "Date",
            // placeholderText:"Select Asset Type",
            // options: [...assetTypeOption],
        },


    ];


    const handleFilterChange = (e, name) => {
        setFilterData((prevFormData) => {
            // Check if the label already exists
            const existingLabelIndex = prevFormData.findIndex(
                (item) => item.label === name
            );

            // If the label exists, update its value
            if (existingLabelIndex !== -1) {
                const updatedFormData = prevFormData.map((item, index) =>
                    index === existingLabelIndex
                        ? { ...item, value: e.value !== undefined ? e.value : e }
                        : item
                );
                return updatedFormData;
            } else {
                // If the label doesn't exist, add a new label-value pair
                return [
                    ...prevFormData,
                    {
                        label: name,
                        value: e.value !== undefined ? e.value : e, // Assuming e is an event object
                    },
                ];
            }
        });
    };

    const handleGetData = async () => {
        try {
            const response = await GetServiceCaller(
                `${API_URL}support-desk-reports/4?P_FromDate=${filterFormData.find((o) => o.label === "From Date")
                    ? moment(filterFormData.find((o) => o.label === "From Date").value).format("YYYY-MM-DD")
                    : ''
                }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
                    ? moment(filterFormData.find((o) => o.label === "To Date").value).format("YYYY-MM-DD")
                    : ''
                }`
            );
            SetApiStatus(response?.status);
            if (response.status === 200) {
                const cleanedData = response?.data?.data;
                setSubscriptionSummaryListData(cleanedData);
                setLoading(false);
            } else {
                console.error(
                    "Failed to fetch Disposed Report. Server responded with status:",
                    response.status
                );
            }
        } catch (error) {
            console.error("Error fetching Disposed Report:", error);
        }
    };

    const handleReset = () => {
        setFilterData([])
        fetchGetSubscriptionSummaryReport()
    }
    return (
        <div className="container-fluid" id="skill_section">
            <div className="container-fluid" id="skill-table-area">
                <div className="row">
                    <Dynamic_PR_table
                        data={subscriptionSummaryListData}
                        columns={columns}
                        itemsPerPage={10}
                        handleReset={handleReset}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        isApiStatus={apiStatus}
                        isRequiredStatus={true}
                        showIcon1={true}
                        isSorting={true}
                        showIcon2={false}
                        formDatas={formDatas}
                        filterFormData={filterFormData}
                        handleGetData={handleGetData}
                        handleChange={handleFilterChange}
                        isFilterRequired={true}
                        isActionRequired={false}
                        isAddNewBtnRequired={false}
                        // formDatas={formDatas}
                        // filterFormData={filterFormData}
                        // handleGetData={handleGetData}
                        // handleChange={handleFilterChange}
                        showIcon3={false}
                        showIcon4={false}
                        showIcon5={false}
                        // handleIcon1={handleEdit}
                        // handleAddNew={handleAddNewVendor}
                        add
                        more
                        function
                        icons={{
                            Icon1: <i class="bi bi-pencil-square icons"></i>,
                            Icon1Text: " Edit",
                            Icon2: <i class="bi bi-trash-fill icons"></i>,
                            Icon3: <i class="bi bi-eye-fill icons"></i>,
                            Icon4: <i class="bi bi-plus-square icons"></i>,
                            Icon4Text: " Add Sub-Contractor",
                        }}
                    />
                </div>
            </div>

        </div>
    )
}

export default SubscriptionSummary